<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/harvest";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Harvests",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('harvests.singular')) }},
    resourceRoute: {default: 'harvests'},
    modelVariable: {default: 'harvest'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('harvests.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('harvests.plural')),
          href: "/harvests",
        },
        {
          text: this.$t("Create New"),
          href: "/harvests/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/harvests', value);
    }
  }
}
</script>
